import { createContext, useEffect, useState } from "react";
import { verifyLicenseWebCrypto } from "../funcs/verifyrsa";

export const auth = createContext();

export default function Authentication({ children }) {
        const [loadingUser, setLoadingUser] = useState(true);
        const [ActivEmp, setActiveEmp] = useState(false);
        const [user,setUser] = useState({
            data: [],
            payment: {
                status: false,
                details: [],
            },
            work: {
                workName: "",
                store: "",
            }
        })
        useEffect(() => {
        const getUser = async () => {
            try {
                const cookie = document.cookie
                    .split("; ")
                    .find(row => row.startsWith("token="));
    
                if (!cookie) throw new Error("License missing");
    
                const token = JSON.parse(decodeURIComponent(cookie.split("=")[1]));
                const status = await verifyLicenseWebCrypto();
                if (!status.isValid) throw new Error("License invalid");
                setUser((prev) => ({
                    ...prev,
                    data: [
                        {
                            id: token.id,
                            name: token.name,
                            logo: token.logo,
                            currency: JSON.parse(token.currency)
                        }
                    ] || [],
                    payment: {
                        ...prev.payment,
                        status: status.isExpired, 
                        details: {
                            expired: token.expired,
                            pay: token.pay
                        }
                    },
                    work: {
                        ...prev.work,
                        workName: token.workName,
                        store: token.store
                    }
                }));
            } catch (error) {

            } finally {
                setLoadingUser(false);
            }
        };
        getUser();
    }, []);
    
    const parent = {
        user,
        ActivEmp, 
        setActiveEmp,
        loadingUser,
        
    }
    
    return <auth.Provider value={parent}>{children}</auth.Provider>
}